import './GitHubButton.css';
import GitHubButtonIcon from './github-button.png';

function GitHubButton() {
  const onButtonClick = () => { window.open('https://github.com/SongRongLee/mir-svc'); };
  return (
    <div className="github-button" onClick={onButtonClick}>
      <span>View on GitHub</span>
      <img className="github-icon" src={GitHubButtonIcon} alt="GitHub" />
    </div>
  );
}

export default GitHubButton;
